import React, { CSSProperties, useEffect, useRef } from 'react';
import classNames from 'clsx';

import {
  CUSTOM_TOGGLE_SWITCH_EVENT,
  DISABLE_CAROUSEL_EVENT,
  ENABLE_CAROUSEL_EVENT,
  FORM_CLOSED_EVENT,
  FORM_SHOWED_EVENT,
  FORM_SUBMITTED_EVENT,
  NEXT_CLICK_EVENT,
  NEXT_CLIP_COMPLETE_EVENT,
  TIMELINE_MARK_CLICK_EVENT,
  TIMELINE_MARK_START_EVENT,
  X_RAY_CLICK_EVENT,
} from './constants/events';

import { VideoType } from '@/modules/common/types/video';

import { usePlayerWidget } from './helpers';

import styles from './Player.module.scss';

type Props = {
  className?: string;
  showLoader?: boolean;
  style?: CSSProperties;
  instanceKey: string;
  playerPropsPassThrow: unknown;
  prevVideo?: VideoType | undefined;
  video: VideoType;
  nextVideo?: VideoType | undefined;
  clipSource: string | number;
  listeners?: {
    [NEXT_CLICK_EVENT]?: () => void;
    [NEXT_CLIP_COMPLETE_EVENT]?: () => void;
    [X_RAY_CLICK_EVENT]?: () => void;
    [ENABLE_CAROUSEL_EVENT]?: () => void;
    [DISABLE_CAROUSEL_EVENT]?: () => void;
    [FORM_SHOWED_EVENT]?: () => void;
    [FORM_CLOSED_EVENT]?: () => void;
    [FORM_SUBMITTED_EVENT]?: () => void;
    [TIMELINE_MARK_CLICK_EVENT]?: () => void;
    [TIMELINE_MARK_START_EVENT]?: () => void;
    [CUSTOM_TOGGLE_SWITCH_EVENT]?: () => void;
  };
};

function Player({
  className = '',
  style,
  showLoader = true,
  playerPropsPassThrow,
  prevVideo,
  video,
  nextVideo,
  clipSource,
  instanceKey,
  listeners,
}: Props) {
  const LWP = usePlayerWidget(instanceKey);
  const containerRef = useRef(null);

  useEffect(() => {
    LWP.reInit({
      container: containerRef.current,
      playerPropsPassThrow,
      prevVideo,
      video,
      nextVideo,
      clipSource,
      listeners: listeners || {},
    });
  }, [video.mediaid]);

  useEffect(() => () => LWP.unmountPlayerContainer(), []);

  return (
    <div
      ref={containerRef}
      className={classNames(
        styles.Player,
        {
          [styles.Player___loading]: showLoader,
        },
        className,
      )}
      style={style}
    />
  );
}

export default Player;
